
function Footer() {
  return           <footer className="page-footer orange darken-1">
  <div className="container">
  </div>
  <div className="footer-copyright">
    <div className="container">
    © {new Date().getFullYear()} Copyright Text
    <a className="grey-text text-lighten-4 right" href="https://github.com/olvsivkov">My GitHub</a>
    </div>
  </div>
</footer>
}

export {Footer}